// Formatação pt-BR

export const WEEKDAYS_SHORT = ["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"];
export const WEEKDAYS_LONG = [
  "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira",
  "Sexta-feira", "Sábado", "Domingo",
];
export const MONTHS = [
  "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
  "Jul", "Ago", "Set", "Out", "Nov", "Dez",
];

// Converte JS getDay() (Dom=0) para índice python (Seg=0..Dom=6)
export const jsToPyWeekday = (jsDay) => (jsDay + 6) % 7;

// 'YYYY-MM-DD' -> 'DD/MM/AAAA'
export const formatDateBR = (iso) => {
  if (!iso) return "";
  return `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}`;
};

// Date object -> 'YYYY-MM-DD' (local)
export const toISODate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

// 'YYYY-MM-DD' de HOJE no fuso America/Sao_Paulo (independe do fuso do navegador)
export const spTodayISO = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" }).format(new Date());

// Soma n dias a uma data ISO ('YYYY-MM-DD') sem drift de fuso
export const addDaysISO = (iso, n) => {
  const d = new Date(iso + "T12:00:00Z");
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};

// Índice python (Seg=0..Dom=6) de uma data ISO, estável (meio-dia UTC)
export const pyWeekdayOfISO = (iso) => jsToPyWeekday(new Date(iso + "T12:00:00Z").getUTCDay());

export const dayNumOfISO = (iso) => Number(iso.slice(8, 10));
export const monthLabelOfISO = (iso) => MONTHS[Number(iso.slice(5, 7)) - 1];

export const formatCurrency = (v) => {
  if (v === null || v === undefined || v === "") return null;
  return `R$ ${Number(v).toFixed(2).replace(".", ",")}`;
};

// Máscara WhatsApp BR: (11) 91234-5678
export const maskPhone = (value) => {
  const d = value.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d.length ? `(${d}` : d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
};

export const STATUS_STYLES = {
  "Confirmado": "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  "Concluído": "bg-sky-500/15 text-sky-400 border-sky-500/30",
  "Cancelado pelo barbeiro": "bg-red-500/15 text-red-400 border-red-500/30",
  "Cancelado pelo cliente": "bg-red-500/10 text-red-300 border-red-500/25",
  "Cliente não compareceu": "bg-amber-500/15 text-amber-400 border-amber-500/30",
};
